import React, {useEffect, useState} from "react";
import {getUserRoles} from 'api';
import {Button, Form, Input, Table, Row, Col, Modal} from "antd";
import {confirmAlert} from "react-confirm-alert";
import AddEditRoleDialog from "../Roles/AddEditRoleDialog";
import {Link} from "react-router-dom";
import {isAdministrator} from "../../../utils/UserInfo";
import {
    commonSorter,
    SearchAndDropdownComponent,
    searchAndDropDownFilters,
    searchAndDropDownOnFilters
} from "../../../utils/AntdTableFunctions";


function RolesView(props){

    const [roles,setRoles] = useState([]);

    useEffect(() => {
        async function getRoles() {
            let roles = await getUserRoles();
            setRoles(roles.data);
        }
        getRoles();
    }, []);

    function EditCellFormatter(cell, row)
    {
        if(isAdministrator())
            return (<Link to={`#`} onClick={() => openEditDialog(row)}><strong>{row.roleName}</strong></Link>);
        else
            return (<>{row.roleName}</>);
    }
    function UpdatedFormatter(cell, row)
    {
        return (
            <div>{row.lastModifiedUser}{' '}{row.lastModifiedDate}</div>
        );
    }
    function CreatedFormatter(cell, row)
    {
        return (
            <div>{row.createdUser}{' '}{row.createdDate}</div>
        );
    }
    function openEditDialog(row)
    {
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <AddEditRoleDialog action={'Edit'} role={row} onClose={onClose} setRoles={setRoles}/>
                );
            }
        });
    }
    function OpenAddNewRoleDialog()
    {
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <AddEditRoleDialog action={'Add'} role={null} onClose={onClose} setRoles={setRoles}/>
                );
            }
        });
    }

    const RoleColumns = [
        {
            title: 'Role ID',
            dataIndex: 'roleId',
            key: 'roleId',
            sorter: (a,b) => commonSorter(a,b,'roleId'),
        },
        {
            title: 'Role Name',
            dataIndex: 'roleName',
            key: 'roleName',
            render: EditCellFormatter,
            sorter: (a,b) => commonSorter(a,b,'roleName'),
            filters: searchAndDropDownFilters('roleName', roles),
            ...SearchAndDropdownComponent(),
            onFilter: (value, record) =>  searchAndDropDownOnFilters(value, record,'roleName'),
        },
        {
            title: 'Order',
            dataIndex: 'orderId',
            key: 'orderId',
            sorter: (a,b) => commonSorter(a,b,'orderId'),
        },
        {
            title: 'Assign Task?',
            dataIndex: 'assignTasksFl',
            key: 'assignTasksFl',
            sorter: (a,b) => commonSorter(a,b,'assignTasksFl'),
        },
        {
            title: 'Disable?',
            dataIndex: 'disableFlag',
            key: 'disableFlag',
            sorter: (a,b) => commonSorter(a,b,'disableFlag'),
        },
        {
            title: 'Created By',
            dataIndex: 'createdUser',
            key: 'createdUser',
            render: CreatedFormatter
        },
        {
            title: 'Modified By',
            dataIndex: 'lastModifiedUser',
            key: 'lastModifiedUser',
            render: UpdatedFormatter
        }
    ];

    return (
        <div>
            <Row>
                <Col>
                    {isAdministrator() &&
                    <Button
                        type='primary'
                        style={{alignItems: 'end', alignContent: 'end'}}
                        onClick={() => OpenAddNewRoleDialog()}
                    >
                        Add New Role
                    </Button>
                    }
                </Col>
            </Row>
            <Table
                bordered
                dataSource={roles}
                columns={RoleColumns}
                pagination={false}
                //pagination={{ showSizeChanger: false, pageSize: 10 }}
                scroll={{ y: true }}
                style={{ paddingTop: '15px', paddingBottom: '15px' }}
            />
        </div>
    )
 }
export default RolesView;